import { useContext } from 'react'
import { FeatureAccessContext } from './FeatureAccessContextDef'

export function useFeatureAccessContext() {
  const context = useContext(FeatureAccessContext)
  if (context === undefined) {
    throw new Error('useFeatureAccessContext must be used within a FeatureAccessProvider')
  }
  return context
}
